import {stationFormat} from "./formatters";
import React from "react";

export function twoDecimals(num, min, max) {
    let str = String(num).split('.');
    if (min && parseInt(str[0], 10) < min) str[0] = min;
    if (max && parseInt(str[0], 10) > max) str[0] = max;
    return str[0] + (str.length > 1 ? '.' + str[1].substring(0, 2) : '.00');
}

export function limitTwoDecimals(num) {
    if (num % 1 === 0) {
        return num
    }
    return parseInt((num * 100), 10) / 100;
}

const priceFormatter = (cell) => {
    return `$ ${cell}`;
};

export const purpleCheckbox = (cell) => {
    return (
        <div className={'custom-checkbox'}>
            {cell &&
            <div className={'red-check'}/>
            }
        </div>
    );
};

export const helpers = {
    groups: {
        ADMINISTRATOR: 'Administrator',
        GENERAL: 'General User',
        PRICING_STAFF: 'Pricing Staff',
        STATION_DM: 'District Manager',
        STATION_TM: 'Territory Manager',
    },
    getGroups: () => {
        let keys = Object.keys(helpers.groups);
        let groups = [];

        for (let i in keys) {
            groups.push({
                value: keys[i],
                label: helpers.groups[keys[i]]
            });
        }

        return groups;
    },
    groupsSelect: [{value: 'ADMINISTRATOR', label: "Administrator"}, {value: 'General User', label: 'General User'},
        {value: 'Pricing Staff', label: 'Pricing Staff'}, {value: 'District Manager', label: 'District Manager'},
        {value: 'Territory Manager', label: 'Territory Manager'}],
    isValidEmail: (e) => {
        // eslint-disable-next-line
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(e);
    },
    checkUserGroup: (groups, user) => {
        if (!user) {
            return false;
        }

        // Sysadmins, Administrators and Programmers can create Trips (FOB)
        let result = false;
        user.roles.forEach(group => {
            if (groups.indexOf(group) > -1) {
                result = true;
            }
        });

        return result;
    },
    getPricesColumns: () => {
        return [
            {
                dataField: 'service_station__global_code',
                text: 'Boca',
                path: 'service_station',
                isCustom: true,
                sort: true
            },
            {
                dataField: 'product__short_name',
                text: 'Producto',
                path: 'product.short_name',
                sort: true
            },
            {
                dataField: 'price',
                text: 'Precio',
                path: 'price',
                sort: true,
                formatter: priceFormatter
            },

        ];
    },
    getAdminColumns: () => {
        return [
            {
                dataField: 'first_name',
                text: 'Nombre',
                path: 'first_name',
                sort: true
            },
            {
                dataField: 'last_name',
                text: 'Apellido',
                path: 'last_name',
                sort: true
            },
            {
                dataField: 'email',
                text: 'Email',
                path: 'email',
                sort: true,
            },
            {
                dataField: 'username',
                text: 'Usuario',
                path: 'username',
                sort: true,
            },
            {
                dataField: 'profile',
                text: 'Perfil',
                path: 'profile',
                isCustom: true,
            },

        ];
    },
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js